import { createSlice } from "@reduxjs/toolkit";
import { TransactionsState } from "./transactions.types";
import {
  getTransactions
} from "./async-thunks";

const initialState: TransactionsState = {
  data: {
    data: [],
    meta: null
  },
  params: {},
  loading: false,
  response: null
};

export const transactionSlice = createSlice({
  name: "transactions",
  initialState,
  reducers: {
    clearTransactions: (state) => {
      state.data = { data: [], meta: null };
      state.params = {};
      state.loading = false;
      state.response = null;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getTransactions.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.data;
      state.params = action.payload.params;
    });
    builder.addCase(getTransactions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTransactions.rejected, (state) => {
      state.loading = false;
    });
  }
});

export const {
  clearTransactions
} = transactionSlice.actions;
export const transactionsReducer = transactionSlice.reducer;
